import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigServiceProvider } from "../../../core/services/config-service/config-service";
import { StorageServiceProvider } from "../../../core/services/storage-service/storage-service";
import {Observable} from "rxjs";
import {RankingDefinition} from "./ranking-definition";
import {Ranking} from "./ranking";

/*
  Generated class for the RankingServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RankingServiceProvider {
  rankingsIds = null;
  rankings = null;
  rankingsDefinitions = null;
  rankingFilters = null;
  rankingGroupFilters = null;
  rankingHistoryFilters = null;

  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {

  }

  load() {
    return Promise.all([
      this.loadAndSaveRankingsDefinitions(),
      this.loadAndSaveRankings()
    ])
  }

  private loadAndSaveRankingsDefinitions() {
    return new Promise((resolve, reject) => {
      this.loadRankingsDefinitions()
        .toPromise()
        .then(response => {
          this.storageService.setObject('rankingDefinitions', response);
          resolve(response);
        })
        .catch(err => {
          console.error(err);
          reject(err);
        })
    })
  }

  private loadAndSaveRankings() {
    return new Promise((resolve, reject) =>
      this.loadRankings()
        .toPromise()
        .then(
          response => {
            let rankings = response;
            let objectRankings = JSON.parse(JSON.stringify(rankings));
            for (let ranking in rankings) {
              let currentRanking = rankings[ranking];
              for (let user in currentRanking) {
                let currentUserRanking = currentRanking[user];
                for (let day in currentUserRanking) {
                  let currentDay = currentUserRanking[day];
                  objectRankings[ranking][user][day].params.kpis = {};
                  for (var kpi in currentDay.params.kpis) {
                    var currentKpi = currentDay.params.kpis[kpi];
                    objectRankings[ranking][user][day].params.kpis[currentKpi.kpiId] = currentKpi;
                  }
                }
              }
            }
            this.storageService.setObject('rankings', objectRankings);
            resolve(objectRankings);
          }
        )
        .catch(err => {
          console.error(err);
          reject(err);
        })
    );
  }

  loadRankingsDefinitions(): Observable<RankingDefinition[]> {
    return this.http.get<RankingDefinition[]>(this.configService.getUrl('rankingDefinitions'));
  }
  loadRankings(): Observable<Map<number, Map<number, Ranking[]>>> {
    return this.http.get<Map<number, Map<number, Ranking[]>>>(this.configService.getUrl('rankings'));
  }

  getRankingDefinitions() {
    return this.storageService.getObject('rankingDefinitions');
  }

  getRankings() {
    return this.storageService.getObject('rankings');
  }

  setFilters(object) {
    this.storageService.setObject('rankingFilters', object);
  }

  getFilters() {
    return this.storageService.getObject('rankingFilters');
  }

  setGroupFilters(object) {
    this.storageService.setObject('rankingGroupFilters', object);
  }

  getGroupFilters() {
    return this.storageService.getObject('rankingGroupFilters');
  }

  setHistoryFilters(object) {
    this.storageService.setObject('rankingHistoryFilters', object);
  }

  getHistoryFilters() {
    return this.storageService.getObject('rankingHistoryFilters');
  }

  getRankingHistory(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('history') + id + '/history').toPromise()
        .then(result => {
          resolve();
        })
        .catch(err => {
          console.error(err);
          reject();
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/ranking/services/ranking-service/ranking-service.ts